export default array => {
  return array.reduce((object, model) => {
    object[model.id] = model;
    return object;
  }, {});
};